import { render, staticRenderFns } from "./MultiSpecificityFormField.vue?vue&type=template&id=5c6f624e&"
import script from "./MultiSpecificityFormField.vue?vue&type=script&lang=ts&"
export * from "./MultiSpecificityFormField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports